import { getComponentFromName } from '@folklore/utils';
import { ComponentType } from 'react';

import * as FieldComponents from '../fields/index';

interface FormQuestionProps {
    field: FormField;
    value?: unknown;
    errors?: string[] | null;
    loading?: boolean;
    labelTag?: 'div' | 'h2' | 'h3';
    className?: string | null;
    labelClassName?: string | null;
    descriptionClassName?: string | null;
    fieldClassName?: string | null;
    onChange?: ((newValue: unknown) => void) | null;
}

/**
 * A question of a form answered on its own: its label, its description and its field, shown with
 * the theme of its type (the buttons of a multiple choice)
 */
function FormQuestion({
    field,
    value = null,
    errors = null,
    loading = false,
    labelTag: LabelTag = 'div',
    className = null,
    labelClassName = null,
    descriptionClassName = null,
    fieldClassName = null,
    onChange = null,
}: FormQuestionProps) {
    const { label = null, description = null, type = null, component = null } = field;
    const FieldComponent = ((component !== null
        ? getComponentFromName(FieldComponents, component)
        : null) ||
        (type !== null ? getComponentFromName(FieldComponents, type) : null) ||
        null) as ComponentType<Record<string, unknown>> | null;
    return (
        <div className={className}>
            {label !== null ? <LabelTag className={labelClassName}>{label}</LabelTag> : null}
            {description !== null ? (
                <div
                    className={descriptionClassName}
                    dangerouslySetInnerHTML={{ __html: description }}
                />
            ) : null}
            {FieldComponent !== null ? (
                <FieldComponent
                    {...field}
                    errors={errors}
                    className={fieldClassName}
                    loading={loading}
                    value={value}
                    onChange={onChange}
                />
            ) : null}
        </div>
    );
}

export default FormQuestion;
